import React, {useMemo} from "react";
import Checkbox from "../forms/checkbox/Checkbox";

interface SegmentCheckboxProps {
    segment: any;
    consentRule: number;
    isSelected: boolean;
    toggleSegment: (segmentId: number, newState: boolean) => void;
}

const SegmentCheckbox = ({ segment, consentRule, isSelected, toggleSegment }: SegmentCheckboxProps) => {
    const segmentMembersCountFieldName = consentRule === 0 ? 'clientsCountEstimation' : consentRule === 1 ? 'clientsCountEstimationEmail' : 'clientsCountEstimationSms';
    const segmentDescription = useMemo(() => {
        return `${segment[segmentMembersCountFieldName]} eligible customers`;
    }, [segment, consentRule]);

    return (
        <Checkbox key={`segment-checkbox-${segment.id}`} disabled={!segment[segmentMembersCountFieldName]} disabledReason="This audience does not have any members" tooltipPlacement="right" label={`${segment.title} (${segmentDescription})`} description={`${segment.description}`} isSelected={isSelected} setIsSelected={(newState) => toggleSegment(segment.id, newState)} />
    );
}

export default SegmentCheckbox;